const body = document.body;
const originHeader = document.querySelector('.header__outer-wrapper');
const stickyHeader = document.querySelector('.sticky_header__outer-wrapper');
const collectionBanner = document.querySelector('.collections-page-links');
const alreadyScrolled = 0;
const scrollUp = "scroll-up";
const scrollDown = "scroll-down";
let breakpointMobile = window.matchMedia('(max-width: 960px)');
let stickHeaderChild = document.querySelector('.header-sticky');
if(stickHeaderChild) {
  if(breakpointMobile.matches) {
    stickHeaderHeight = 3.5;
  } else {
    stickHeaderHeight = 4.5;
  }
}
window.addEventListener('resize', event => {
  if(window.matchMedia('(max-width: 768px)').matches) {
    stickHeaderHeight = 3.5;
  } else {
    stickHeaderHeight = 4.5;
  }
})
document.querySelector('.sticky_header__outer-wrapper').style.setProperty("visibility", "hidden");
let lastScroll = 0;
window.addEventListener("load", () => {
  stickHeaderChild.style.setProperty('display', 'block');
})
window.addEventListener("scroll", () => {
  const currentScroll = window.pageYOffset;
  if (currentScroll <= 80) {
    body.classList.remove(scrollUp);
    document.querySelector('.sticky_header__outer-wrapper').style.setProperty("visibility", "hidden");
    document.querySelector('.header__outer-wrapper').style.setProperty("visibility", "visible");

    const stickyCollectionBar = document.querySelector(".collections-navigation-bar");
    if(stickyCollectionBar) {
      stickyCollectionBar.classList.remove('is-flexed');
    }
    return;
  }
  if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
    // down
    body.classList.remove(scrollUp);
    body.classList.add(scrollDown);
    originHeader.style.setProperty("visibility", "hidden");
    stickyHeader.style.setProperty("visibility", "hidden");
    stickyHeader.style.setProperty("z-index", "12");

    setTimeout(() => {
      const stickyCollectionBar = document.querySelector(".collections-navigation-bar");
      if(stickyCollectionBar) {
        stickyCollectionBar.classList.remove('is-flexed');
      }
    });
  } else if (
    currentScroll < lastScroll &&
    body.classList.contains(scrollDown)
  ) {
    // up
    body.classList.remove(scrollDown);
    body.classList.add(scrollUp);
    originHeader.style.setProperty("visibility", "visible");
    stickyHeader.style.setProperty("visibility", "visible");
    stickyHeader.style.setProperty("z-index", "999");
    setTimeout(() => {
      const stickyCollectionBar = document.querySelector(".collections-navigation-bar");
      if(collectionBanner) {
        if((collectionBanner.getBoundingClientRect().top <= window.innerHeight) && 
        ((collectionBanner.getBoundingClientRect().bottom + window.innerHeight) > window.innerHeight)) {
          if(stickyCollectionBar) {
            stickyCollectionBar.style.setProperty('top', 0);
            stickyCollectionBar.classList.remove('is-flexed');
          }
        } else {
          if(stickyCollectionBar) {
            stickyCollectionBar.style.setProperty('top', `${stickHeaderHeight}rem`);
            stickyCollectionBar.classList.add('is-flexed');
          }
        }
      }
    });
  }
  lastScroll = currentScroll;
});

// FIX BURGER MENU NOT OPENING ON THE STICKY HEADER IN MOBILE 
const burgerButton = document.querySelector('#sticky-header-burger');
const closeButton = document.querySelector('.drawer-menu-sticky .drawer-menu__close-icon');
const drawer = document.querySelector(".drawer-menu-sticky .drawer-menu");
const backButtons = document.querySelectorAll('.drawer-menu-sticky .drawer-menu__bottom .drawer-menu-list--1 .drawer-menu__link[data-item="back"]');
const childDrawers = document.querySelectorAll(".drawer-menu-sticky .drawer-menu__bottom .drawer-menu-list--1");
burgerButton.addEventListener("click", () => {
  drawer.classList.add("active");
  window.setTimeout(function () {
    drawer.classList.add("visible");
  }, 300);
})
closeButton.addEventListener("click", () => {
  drawer.classList.remove("visible");
  window.setTimeout(function () {
    drawer.classList.remove("active");
  }, 300);
})
if(backButtons.length > 0) {
  backButtons.forEach(button => {
    button.addEventListener("click", () => {
      childDrawers.forEach( drawer => {
        drawer.classList.remove("visible");
        window.setTimeout(function () {
          childDrawers.forEach( drawer => drawer.classList.remove("active"))
        }, 300);
      })
    })
  })
}